/**Dependencies */
import React, { useEffect, useState } from "react";
import { calculateBookingDates } from "../helpers";
/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { BannerExperience } from "../components/BannerExperience";
import { PromotionsList } from "../components/PromotionsList";
import { Link } from "react-router-dom";
import { SectionOurServices } from "../components/SectionOurServices";

/**Images */
import bannerCampamentoVerano from "../images/banners/banner-campamentos-verano.png";
import bannerIntermedio from "../images/banners/banner reservas sin intereses.jpg";
import textCampamentos from "../images/texto campamentos.png";

import iconDiamante from "../images/icons/icon-diamante.png";
import iconReloj from "../images/icons/icon-reloj.png";
import iconSeguridad from "../images/icons/icon-seguridad.png";
import iconSoporte from "../images/icons/icon-soporte.png";

import logoValores1 from "../images/Logo British Council.png";
import logoValores2 from "../images/Logo Languages Canada.png";
import logoValores3 from "../images/SECTUR.png";
import logoValores4 from "../images/ssl.png";
import logoValores5 from "../images/logo-turismo.png";

/**Styles */
import "../styles/home.scss";
import { elementoPorSeccion } from "../services/adminProductService";

export const Home = ({ idElemento = 1 }) => {
  useEffect(() => {
    sessionStorage.clear();
  }, []);

  const { checkIn, checkOut } = calculateBookingDates();
  const [imgsBanners, setImgsBanners] = useState([]);
  const [destinosImg, setDestinosImg] = useState([]);

  const cards = [
    {
      icon: iconDiamante,
      description:
        "Agencia de Viajes con más de 28 años de experiencia, especializada en cursos y campamentos al extranjero.",
    },
    {
      icon: iconReloj,
      description:
        "Ofrecemos un servicio al cliente personalizado para las necesidades específicas de cada cliente.",
    },
    {
      icon: iconSeguridad,
      description:
        "Contamos con la última y más segura tecnología de viajes. Cuidamos los datos de nuestros clientes bajo los parámetros más estrictos del mercado.",
    },
    {
      icon: iconSoporte,
      description:
        "En nuestro equipo contamos con expertos en viajes con amplia experiencia en el sector, que están dispuestos a ayudarte en todo los que necesites.",
    },
  ];

  useEffect(() => {
    const fetchElemento = async () => {
      try {
        const response = await elementoPorSeccion(idElemento);

        const formattedImages = response[1].imagenes.map((img) => ({
          image: img.url,
          texto: img.texto,
        }));

        const formattedImagesDestinos = response[2].imagenes.map((img) => ({
          image: img.url,
          texto: img.texto,
        }));

        setImgsBanners(formattedImages);

        setDestinosImg(formattedImagesDestinos);
      } catch (err) {
        console.error("Error al cargar las imágenes:", err);
      }
    };

    fetchElemento();
  }, [idElemento]);

  return (
    <div className="home">
      <PrincipalBanner idElemento={1} showSearch={true} />

      <div className="container mt-5 py-5">
        <div>
          <div className="carousel-container pb-5">
            <h1 className="text-center section-title" id="titulo">Circuitos Internacionales</h1>
            <iframe src="https://nefertaritravel.com.mx/mystaging01/carrusel-garantizadas" title='iframe-megatravel' border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '500px' }}></iframe>
            {/* <iframe title='frame-circuits' src="https://www.megatravel.com.mx/tools/ofertas-viaje.php?Dest=&txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1"
              border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '700px' }}> </iframe> */}
          </div>
        </div>
      </div>

      <Container className="py-5" style={{ position: "relative", zIndex: 0 }}>
        <div className="text-center mt-5 mb-5">
          <h1 className="section-title outline">
            Tu próximo viaje comienza aquí, explora los servicios que tenemos
            para ti
          </h1>
        </div>
        <div className="carousel-container pb-5">
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
          >
            {imgsBanners.map((image, index) => (
              <SwiperSlide key={index}>
                <Link to={"/" + image.texto}>
                  <img
                    src={`https://panel.internationaltravelnet.com.mx/assets/uploads/elementos/${image.image}`}
                    alt={`Imagen ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "515px",
                      marginBottom: "15px",
                      objectFit: "cover",
                    }}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>

      <div className="container">
        <div>
          <div className="carousel-container pb-5">
            <h1 className="text-center section-title" id="titulo">Destinos para visitar</h1>
            <iframe src="https://nefertaritravel.com.mx/mystaging01/carrusel-garantizadas" title='iframe-megatravel' border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '500px' }}></iframe>
            {/* <iframe title='frame-circuits' src="https://www.megatravel.com.mx/tools/ofertas-viaje.php?Dest=&txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1"
              border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '700px' }}> </iframe> */}
          </div>
        </div>
      </div>

      <div className="image-container mt-3 mb-5">
        <img
          className="w-100"
          src={bannerIntermedio}
          alt="Fondo"
        />
      </div>

      <div className="image-container">
        <img
          src={bannerCampamentoVerano}
          alt="Fondo"
          className="background-image"
        />
        <img
          src={textCampamentos}
          alt="Superpuesta"
          className="overlay-image"
        />
      </div>

      <div className="py-5">
        <SectionOurServices />
      </div>

      <div
        className="py-5"
        style={{ backgroundColor: "#efefef", padding: "50px 0" }}
      >
        <Container>
          <div className="text-center mb-5">
            <h1 className="section-title">¿Por qué reservar con nosotros?</h1>
            <p className="section-subtitle">
              Estamos enfocados en la innovación dentro de un mundo de constante
              evolución para proporcionarte grandes vivencias en tu viaje.
            </p>
          </div>

          <Row className="text-center">
            {cards.map((card, index) => (
              <Col key={index} md={3} sm={6} xs={12} className="mb-4">
                <Card className="h-100 shadow border-0">
                  <Card.Body>
                    <div style={{ height: "130px" }}>
                      <img
                        className="my-5"
                        src={card.icon}
                        style={{ width: "60px" }}
                        alt={"icono " + index}
                      />
                    </div>
                    <Card.Text
                      className="py-5 text-secondary"
                      style={{
                        textAlign: "justify",
                        fontSize: "16px",
                        padding: "10px",
                        fontWeight: 600,
                      }}
                    >
                      {card.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      <div className="container py-5">
        <div className="text-center mt-5 mb-5">
          <h1 className="section-title">Promociones</h1>
        </div>
        <PromotionsList isHome={true} />
      </div>

      <div className="py-5">
        <div className="text-center mt-5 mb-5">
          <h1 className="section-title outline">Encuentra tu destino</h1>
          <p className="section-subtitle">
            Vive una experiencia International Travel Net
          </p>
        </div>
        <div className="carousel-container pb-5">
          <Swiper
            className="d-grid justify-content-center"
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 5,
              },
            }}
          >
            {destinosImg.map((image, index) => (
              <SwiperSlide key={index}>
                <Link
                  to={`/alojamientos?t=destino&id=${image?.texto}&in=${checkIn}&out=${checkOut}&hab=1&pax1=2|0|0`}
                >
                  <img
                    src={`https://panel.internationaltravelnet.com.mx/assets/uploads/elementos/${image?.image}`}
                    alt={`Imagen ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "700px",
                      marginBottom: "15px",
                    }}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="py-5">
        <BannerExperience />
      </div>
      <div className="py-5">
        <Container className="py-5">
          <div className="text-center mb-5">
            <h1 className="section-title mt-5">Valores de confianza</h1>
          </div>
          <Row className="text-center align-items-start justify-content-center">
            <Col md={2} sm={6} xs={6} className="mb-4">
              <img
                src={logoValores1}
                alt={`Imagen 1`}
                className="img-fluid mb-2"
                style={{ width: "170px", paddingTop: "20px" }}
              />
            </Col>
            <Col md={2} sm={6} xs={6} className="mb-4">
              <img
                src={logoValores2}
                alt={`Imagen 1`}
                className="img-fluid mb-2"
                style={{ width: "170px" }}
              />
            </Col>
            <Col md={2} sm={6} xs={6} className="mb-4">
              <img
                src={logoValores3}
                alt={`Imagen 1`}
                className="img-fluid mb-2"
                style={{ width: "190px", paddingTop: "30px" }}
              />
            </Col>
            <Col md={2} sm={6} xs={6} className="mb-4">
              <img
                src={logoValores4}
                alt={`Imagen 1`}
                className="img-fluid mb-2"
                style={{ width: "130px", paddingTop: "20px" }}
              />
            </Col>
            <Col md={2} sm={6} xs={6} className="mb-4">
              <img
                src={logoValores5}
                alt={`Imagen 1`}
                className="img-fluid mb-2"
                style={{ width: "190px", paddingTop: "20px" }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
